module.exports = __webpack_public_path__ + "static/media/icon-next.5421c364.svg";